import { t } from 'i18next';
import * as qs from 'query-string';

import { ReactComponent as BookIcon } from 'assets/icons/closed-book.svg';
import ThemeCheckBox from 'components/Input/CheckBox/ThemeCheckBox';

import './Chapter.scoped.scss';

interface Props {
  id: number | string;
  title: string;
  isCompleted: boolean;
  body: any;
  selectAndUpdateChapter: any;
  current?: string;
  percentage?: number;
  duration?: number;
}

const Section: React.FC<Props> = ({ id, title, isCompleted, body, selectAndUpdateChapter }) => {
  const { lesson } = qs.parse(window.location.search);

  const handleIsCompletedClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
  };

  return (
    <div
      key={id}
      onClick={() => {
        selectAndUpdateChapter(body, id, title);
      }}
      className={`${lesson === id && 'is-current'} container pointer`}
    >
      <div className="flex">
        <ThemeCheckBox
          //   label={title}
          checked={isCompleted}
          spanStyle={{
            borderRadius: 5,
            border: !isCompleted ? '1px solid #CFD6DD' : 'none',
            backgroundColor: !isCompleted ? 'white' : '',
          }}
          onChange={handleIsCompletedClick}
        />
      </div>
      <div className="progress-container">
        <p className="title">{title}</p>
        <div className="progress-info">
          {body === '<p>Quiz</p>' ? <BookIcon /> : <BookIcon />}
          <p>{`${isCompleted ? '100' : '0'}% ${t('study:complete')}`}</p>
          {/* {!is_completed && <p> | 35 min left</p>} */}
        </div>
      </div>
    </div>
  );
};

export default Section;
